import { Component } from '@angular/core';
import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';
import { ColdObservable } from 'rxjs/internal/testing/ColdObservable';

const ChevTheme = definePreset(Material, {
    semantic: {
        primary: {
            50: "#E3F2FD",
            100: "#BBDEFB",
            200: "#90CAF9",
            300: '#2196f3',
            400: '#4baaf5',
            500: '#2196f3',
            600: "#1E88E5",
            700: "#1976D2",
            800: "#1565C0",
            900: "#0D47A1",
            950: "#072451"
        }
    },
    components: {
        button: {
            borderRadius: "0",
        },
        datatable: {
            headerCell: {
                selectedColor: "#2196f3"
            }
        },
        tag: {
            fontSize: "1.5rem",
            roundedBorderRadius: "border.radius.none"
        },
        inputtext: {
            fontSize: "1.5rem",
            focusRing:{
                style: "none",
            }
        },
        tieredmenu: {
            background: 'rgb(0, 102, 178)',
            borderRadius: 'none',
            borderColor: 'none',
            item: {
                color: '#ffffff',
                focusBackground: 'rgb(0, 102, 178)',
                focusColor: '#ffffff',
                activeBackground: 'rgb(0, 102, 178)',
                padding: '1rem 2rem',

            },
            submenu: {
                border: 'none'
            },
            submenuIcon: {
                color: 'rgb(0, 102, 178)',
            }

        },
        toggleswitch: {
            root: {
                height: '2rem',
                width: '3rem',
                gap: '0.2rem',
                borderWidth: '0',
            },
            handle: {
                size: '1.4rem'
            },
            colorScheme: {
                light: {
                    root: {
                        checkedBackground: '#2196f3',
                        checkedHoverBackground: '#0d89ec',
                    },
                    handle: {
                        checkedBackground: '#ffffff',
                        checkedHoverBackground: '#ffffff',
                    }
                }
            }
        },
        dialog:{
            borderColor: 'none'
        },
        floatlabel: {
            active: {
                fontSize: "1rem",
            },
        },
        togglebutton: {
            root: {
                borderRadius: 'none',
                checkedColor: '#ffffff',
            },
            colorScheme: {
                light: {
                    root: {
                        checkedBackground: '#2196f3'
                    }
                }
            }
        },
        selectbutton: {
            borderRadius: "0px"
        },
        tabmenu: {
            item: {
                padding: '0px',
                color: '#4baaf5'
            }
        }
    },

} as any);

export default ChevTheme;
